<script lang="ts">
import api, { Command } from '../api';
import Input from './Input.svelte';
import Button from './Button.svelte';

export let id: string;
let email: string;
let locked = false;
let sent = false;
let error = '';

async function sendEmail(): Promise<void> {
    if (locked) {
        return;
    }

    locked = true;
    sent = false;
    error = '';

    try {
        await api.post(Command.SendTestEmail, { id, emails: [email] });
        sent = true;
    } catch (err) {
        error = (err as Error).message || 'Не удалось отправить письмо';
    } finally {
        locked = false;
    }
}
</script>

<style lang="scss">
fieldset {
    display: flex;
    border: 0;
    padding: 0;
    margin: 24px 0;

    :global(.input) {
        flex: 1 1;
        padding-right: 24px;
    }
}

.error {
    color: red;
}
</style>
<form action="" method="POST" on:submit|preventDefault={sendEmail}>
    <h2>Тестовое письмо</h2>
    <fieldset>
        <Input name="testEmail" bind:value={email} placeholder="Куда отправить"></Input>
        <Button type="submit" role="primary" disabled={locked}>Отправить</Button>
    </fieldset>
    {#if sent}
        <p>Тестовое письмо отправлено</p>
    {/if}
    {#if error}
        <p class="error">{error}</p>
    {/if}
</form>
